import { FC, useContext } from "react";

import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";

import { useIsDiscountUser, useShowUnifiedCard } from "../../hooks";
import { DiscountCardBack } from "./DiscountCard";
import { NonDiscountCardBack } from "./NonDiscountCard";
import { UnifiedCardBack } from "./UnifiedCard";

export const MemberCardBack: FC = () => {
  const { memberEligibility } = useContext(MemberEligibilityContext);
  const { isDiscountUser } = useIsDiscountUser();
  const { showUnifiedCard } = useShowUnifiedCard();

  if (isDiscountUser) {
    return <DiscountCardBack />;
  } else if (showUnifiedCard) {
    return <UnifiedCardBack memberEligibilityInfo={memberEligibility} />;
  } else {
    return <NonDiscountCardBack memberEligibilityInfo={memberEligibility} />;
  }
};
